import React from 'react'
import { _ONBOARDED } from '@app/lib/cookies/names'
import { GrNotification } from 'react-icons/gr'
import { Button } from '../general'
import { useInteractiveContext } from '../providers/interactive'
import { ModalType } from '@app/data/enums'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { Dialog } from '@headlessui/react'
import { useRouter } from 'next/router'

// initial prompt that appears
export function Onboarding() {
  const { t } = useTranslation('dashboard-modal')
  const { setModal } = useInteractiveContext()
  const router = useRouter()

  const onClose = () =>
    setModal({ open: false, modalType: ModalType.empty, url: '' })

  const onTakeMeEvent = () => {
    onClose()
    router.push('/settings#notification-selector')
  }

  return (
    <div className={'px-4 py-4 space-y-4'}>
      <div className='space-y-3'>
        <GrNotification fontSize='large' className='grIcon' />
        <Dialog.Title className='text-lg md:text-xl lg:text-xl xl:text-xl'>
          {t('onboarding.limitEmailsTitle')}
        </Dialog.Title>
        <Dialog.Description>
          {t('onboarding.limitEmailsDetail')}
        </Dialog.Description>
      </div>
      <div className='space-x-3'>
        <Button
          className={`border-2 rounded px-3 py-2 hover:text-blue-400 hover:border-blue-400 dark:hover:text-blue-500 dark:hover:border-blue-500`}
          type={'button'}
          onClick={onTakeMeEvent}
        >
          {t('onboarding.take-me')}
        </Button>
        <Button
          className={
            'bg-transparent border-0 hover:text-gray-400 dark:text-gray-200 dark:hover:text-gray-500'
          }
          onClick={onClose}
          border={false}
        >
          {t('close')}
        </Button>
      </div>
    </div>
  )
}
